import { Auth, Storage } from "aws-amplify";
import _ from "lodash";
import TextField from "@material-ui/core/TextField";
import React from "react";

export const FAQ_CONNECTION_NAMES = ["faq", "faq-dev"];

export const serializeRestConnector = (connectorTemplate, clientId, clientSecret, url) => {
  const params = [
    { name: "connection_name", value: connectorTemplate.connectionName },
    { name: "type", value: connectorTemplate.type },
    { name: "authorization_uri", value: connectorTemplate.data.authorization_uri },
    { name: "app_client_id", value: clientId },
    {
      name: "redirect_uri",
      value: ["alexa", "lex", "voicehub"]
        .reduce((redirectUris, key) => {
          const redirectUri = connectorTemplate.data.redirect_uri[key];

          if (redirectUri) {
            redirectUris.push(redirectUri);
          }

          return redirectUris;
        }, [])
        .join("\r\n")
    },
    { name: "grant_type", value: connectorTemplate.data.grant_type },
    { name: "token_uri", value: connectorTemplate.data.token_uri },
    { name: "app_client_secret", value: clientSecret },
    { name: "auth_scheme", value: connectorTemplate.data.auth_scheme },
    { name: "connector_name", value: connectorTemplate.connectorName },
    { name: "image", value: connectorTemplate.image ? connectorTemplate.image : "" },
    { name: "subdomain_url", value: url }
  ];

  if (connectorTemplate.data["scope"]) params.push({ name: "scope", value: connectorTemplate.data["scope"] });
  if (connectorTemplate["base_url"]) params.push({ name: "base_url", value: connectorTemplate["base_url"] });
  // The Lambda function requires connector data to be serialized into a single string
  return params
    .map(param => {
      return `${param.name}=${encodeURIComponent(param.value)}`;
    })
    .join("&");
};

export const serializeJDBCConnector = connectorTemplate => {
  const params = [
    { name: "connection_name", value: connectorTemplate.connectionName },
    { name: "type", value: connectorTemplate.type },
    { name: "host", value: connectorTemplate.data.host },
    { name: "username", value: connectorTemplate.data.username },
    { name: "password", value: connectorTemplate.data.password },
    { name: "port", value: connectorTemplate.data.port },
    { name: "database", value: connectorTemplate.data.database },
    { name: "connector_name", value: connectorTemplate.connectorName },
    { name: "image", value: connectorTemplate.image ? connectorTemplate.image : "" }
  ];

  // The Lambda function requires connector data to be serialized into a single string
  return params
    .map(param => {
      return `${param.name}=${encodeURIComponent(param.value)}`;
    })
    .join("&");
};

export const serializeCustomSlotTypeValue = (value, synonyms, customId) => {
  let serializedSynonyms = "";
  let serializedCustomId = "";

  if (
    synonyms &&
    synonyms.length > 0 &&
    // Parsed slot values without synonyms have synonyms set to a list with one empty string
    // Check out handleSlotValues in views/CustomSlots/CustomSlotsTable.js for more info
    synonyms[0] !== ""
  ) {
    serializedSynonyms = `[${synonyms.map(synonym => `"${synonym}"`).join(", ")}]`;
  }

  if (customId) {
    serializedCustomId = `{"${customId}"}`;
  }

  return `${value}${serializedSynonyms}${serializedCustomId}`;
};

export const openURLInNewTab = url => {
  window.open(url, "_blank");
};

export const openURLInNewWindow = url => {
  window.open(url, "_blank", "location=yes,height=800,width=1324");
};

export const connectorPlaceholderImage = "https://ev-pre-prod-multimedia.s3.amazonaws.com/connector-empty.png";

export const generateUserPicture = async (user, params) => {
  console.log("https://ui-avatars.com/api/?rounded=true&name" + params);
  const response = await fetch("https://ui-avatars.com/api/?rounded=true&name=" + params);

  const blob = await response.blob();

  Storage.put(params + "_initials.png", blob, {
    contentType: "application/octet-stream"
  })
    .then(result => {
      if (user) {
        Auth.updateUserAttributes(user, {
          picture: "https://s3.amazonaws.com/ev-pre-prod-profile-pics/public/" + result.key
        })
          .then(result => console.log("RES", result))
          .catch(error => console.log("Err", error));
      } else {
      }
    })
    .catch(err => console.error(err));

  return "https://s3.amazonaws.com/ev-pre-prod-profile-pics/public/" + params + "_initials.png";
};

// makes links clickable
export function linkClickable(message, requestResponse) {
  let msg = message;
  let regex = /(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/;
  let position = msg.search(regex);

  if (position !== -1) {
    let hasSrc = msg.slice(position - 7, position - 1);

    if (hasSrc.indexOf("src") === -1) {
      let msgBeforeLink = msg.slice(0, position);
      let endOfLink = msg.slice(position).search(/\s/);
      let link,
        msgAfterLink = "",
        httpLink = "";

      if (endOfLink === -1) {
        link = msg.slice(position);
      } else {
        link = msg.slice(position, position + endOfLink);
        msgAfterLink = msg.slice(position + endOfLink);
      }

      // TODO link should have http(s):// if it doesn't
      if (link.slice(0, 4).toLowerCase() !== "http") {
        httpLink = "http://";
      }

      message =
        msgBeforeLink +
        '<a href="' +
        httpLink +
        link +
        '" target="_blank" class="' +
        requestResponse +
        'Link">' +
        link +
        "</a>" +
        msgAfterLink;
    }
  }
  return message;
}

export function storeChatConfigInStorage(config) {
  localStorage.setItem("ChatProperties", window.btoa(JSON.stringify(config)));
}

export function getWholeChatConfig(username) {
  let chatPreferences = localStorage.getItem("ChatProperties");
  let storage;
  storage = chatPreferences === null ? null : window.atob(chatPreferences);
  if (storage) {
    storage = JSON.parse(storage);
    if (!storage.chat.hasOwnProperty(username)) {
      storage.chat = { ...storage.chat, [username]: { config: {} } };
    }
  } else {
    storage = {
      chat: {
        [username]: {
          config: {}
        }
      }
    };
  }

  return storage;
}

export function getChatConfigProp(state, prop) {
  return _.get(
    state,
    `chat.${state.auth.cognitoUser.username}.config.${prop}`,
    _.get(
      _.get(
        JSON.parse(
          localStorage.getItem("ChatProperties") === null ? null : window.atob(localStorage.getItem("ChatProperties"))
        ),
        `chat["${state.auth.cognitoUser.username}"]`,
        {}
      ),
      `config.${prop}`,
      false
    )
  );
}

export const renderTextField = ({ label, input, meta: { touched, invalid, error }, ...custom }) => (
  <TextField
    label={label}
    placeholder={label}
    error={touched && invalid}
    helperText={touched && error}
    {...input}
    {...custom}
  />
);

export const isString = obj => {
  return typeof obj === "string" || obj instanceof String;
};

export const formatDate = (datetime, locale = "en-US") => {
  const date = new Date(datetime);
  const options = {
    year: "numeric",
    month: "numeric",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric"
  };
  const dateTimeFormat = new Intl.DateTimeFormat(locale, options);
  return dateTimeFormat.format(date);
};
